import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginView from '../views/LoginView.vue'
import MainView from '../views/MainView'

const original = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return original.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: LoginView
  }, {
    path: '/main',
    name: 'MainView',
    component: MainView,
    redirect: '/main/goodsview',
    children: [
      //订单管理中心
      { path: 'moneylog', name: 'MoneyLog', component: () => import('../views/MoneyLogView') },
      { path: 'orderview', name: 'OrderView', component: () => import('../views/OrderView') },
      { path: 'ordermanagerview', name: 'OrderManagerView', component: () => import('../views/OrderManagerView') },
      { path: 'ordercommissionview', name: 'OrderCommissionView', component: () => import('../views/OrderCommissionView') },

      //代理管理中心
      { path: 'agentview', name: 'AgentView', component: () => import('../views/AgentView') },
      { path: 'agentdetailview', name: 'AgentDetailView', component: () => import('../views/AgentDetailView') },

      //产品管理中心
      { path: 'goodsview', name: 'GoodsView', component: () => import('../views/GoodsView') },

      //用户管理中心
      { path: 'userview', name: 'UserView', component: () => import('../views/UserView') },
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
